var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"graph_icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","width":"100%","height":"100%"},on:{"click":function($event){return _vm.$emit('click',$event)}}},[_c('path',{attrs:{"d":_vm.icons[_vm.icon]}})])
}
var staticRenderFns = []

export { render, staticRenderFns }